import { TableHeader, TableRow, TableHead } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import type { Table } from "@tanstack/react-table";

interface SkeletonTableHeaderProps<TData = any> {
  columnsLength?: number;
  columnWidths?: string[];
  headerClassName?: string;
  columnNames?: string[];
  table?: Table<TData>;
}

export function SkeletonTableHeader<TData = any>({
  columnsLength,
  columnWidths,
  headerClassName,
  columnNames,
  table,
}: SkeletonTableHeaderProps<TData>) {
  const headers = table?.getFlatHeaders() || [];
  const finalColumnsLength = headers.length > 0 ? headers.length : (columnsLength ?? 0);

  const extractedColumnNames =
    headers.length > 0
      ? headers.map((header) => {
          const headerContent = header.column.columnDef.header;
          if (typeof headerContent === "string") {
            return headerContent;
          }

          return null;
        })
      : columnNames || [];

  return (
    <TableHeader className={cn("table-header", headerClassName)}>
      <TableRow>
        {Array.from({ length: finalColumnsLength }).map((_, index) => (
          <TableHead
            key={index}
            style={
              columnWidths?.[index]
                ? {
                    width: columnWidths[index],
                    minWidth: columnWidths[index],
                    maxWidth: columnWidths[index],
                  }
                : undefined
            }
          >
            {extractedColumnNames?.[index] === null ? (
              ""
            ) : extractedColumnNames?.[index] ? (
              extractedColumnNames[index]
            ) : (
              <Skeleton className="h-4 w-3/4" />
            )}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
}
